<div class="lamp-info-card">
  <img alt="lamp-img" *ngIf="isValidImage && data.imageObservable | async as pic; else loading" class="image" [attr.src]="pic" (error)="setDefaultImage()" />
  <div *ngIf="!isValidImage" class="default-image">
    <span class="fa fa-picture-o fa-2x"></span>
    <label class="default-image-label">{{ 'module.productCatalogManagement.lampProduct.noPictureText' | translate }}</label>
  </div>

  <div class="content">
    <div class="row-section">
      <div class="value-group">
        <h5 class="value price">{{ data.netPrice | number: '1.0-0' : 'es' }} €</h5>
      </div>
    </div>
    <div class="value-group">
      <h4 class="model">{{ data.name }}</h4>
      <h5 class="consumption">Energieverbrauch: ca. {{ data.annualEnergyConsumption | number: '1.0-0' : 'es' }} kWh/a</h5>
    </div>
  </div>

  <div class="actions">
    <button class="btn btn-outline-primary" (click)="select(data)">{{ 'module.productCatalogManagement.lampProduct.editButtonText' | translate }}</button>
    <a class="delete-link" target="_blank" (click)="delete(data)">{{ 'module.productCatalogManagement.lampProduct.deleteButtonText' | translate }}</a>
  </div>

  <ng-template #loading>
    <div class="spinner">
      <mat-spinner [strokeWidth]="5"></mat-spinner>
    </div>
  </ng-template>
</div>
